<template>
  <div class="flex items-center">
    <vs-avatar :src="params.data.pictureUrl" class="flex-shrink-0 mr-2" size="30px" />
    {{ params.value }}
  </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
  computed: {
    url () {
      return `/management/user/form/${this.params.data.code}`
      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    }
  }
}
</script>
